import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import constants from 'Constants';
import * as paths from 'Paths';



const CouponsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/coupons" */
    'routes/Control/Coupons/CouponsRoute'
  )
));


const getControlCouponsRoutes = () => {
  return [
    {path: paths.getPathControlCoupons(), component: CouponsRoute},
  ]
}



export { getControlCouponsRoutes };
